import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutation = graphql`
  mutation createMerchantNameMutation(
    $input: CreateMerchantNameInput!
    $storeId: ID!
  ) {
    createMerchantName(input: $input) {
      storeLists {
        ...MerchantNames_storeLists
      }
      errors {
        key
        messages
      }
    }
  }
`;

const createMerchantName = (
  environment,
  params,
  listsId,
  storeId,
  args = {}
) => {
  return commit(environment, {
    mutation,
    variables: {
      input: params,
      storeId,
    },
    configs: [
      {
        type: 'RANGE_ADD',
        parentID: listsId,
        edgeName: 'merchantNameEdge',
        connectionInfo: [
          {
            key: 'MerchantNames_storeLists',
            rangeBehavior: 'append',
          },
        ],
      },
    ],
    ...args,
  });
};

export default createMerchantName;
